import React, {Component} from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import {colors} from '../../../../../common/constants/colors';
import CustomTooltip from './tooltip/index';

class BarChartInBudgetsAndSales extends Component {
  renderSalesBar() {
    if (!this.props.showSalesData) {
      return null;
    }
    return <Bar dataKey='Ventas' fill={colors[0]} />;
  }

  renderBudgetsBar() {
    if (!this.props.showBudgetData) {
      return null;
    }
    return <Bar dataKey='Presupuesto' fill={colors[1]} />;
  }

  render() {
    const {data} = this.props;
    return (
      <ResponsiveContainer width='100%' height={300}>
        <BarChart
          data={data}
          margin={{'top': 30, 'right': 20, 'left': 5, 'bottom': 5}}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' />
          <YAxis />

          <Tooltip content={<CustomTooltip />} />
          <Legend />

          {this.renderSalesBar()}
          {this.renderBudgetsBar()}
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default BarChartInBudgetsAndSales;
